import React from 'react';

import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { selectors as authSelectors } from '../../../slices/auth';
import { IUser } from '../../../slices/users/user';
import { RootState } from '../../../slices/rootReducer';
import { TypeDispatchFunction } from '../../../tsHelpers';
import { fetchCreditsPools } from '../../../slices/credits/creditsPools/creditsPools.thunk';
import {
  CreditsPoolsDashboardWithDataContainer
} from '../../credits/views/CreditsPoolsDashboard/CreditsPoolsDashboardWithData/CreditsPoolsDashboardWithDataContainer';

interface IMapStateToProps {
  user: IUser | null;
}

interface IMapDispatchProps {
  fetchCreditsPools: TypeDispatchFunction<typeof fetchCreditsPools>;
}

type Props = IMapStateToProps & IMapDispatchProps & RouteComponentProps;

class CreditsUserFacingDashboardClass extends React.Component<Props> {
  componentDidMount() {
    const { user, fetchCreditsPools } = this.props;
    if (!user?.accountId) {
      return;
    }
    fetchCreditsPools(user.accountId);
  }

  render() {
    const { user } = this.props;
    if (!user?.accountId) {
      return null;
    }
    return <CreditsPoolsDashboardWithDataContainer />;
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    user: authSelectors.getLoggedInUser(state)
  };
};

const mapDispatchToProps: IMapDispatchProps = {
  fetchCreditsPools
};

export const CreditsUserFacing = connect(mapStateToProps, mapDispatchToProps)(
  withRouter(CreditsUserFacingDashboardClass)
);
